import { call, takeLatest, put } from "redux-saga/effects";
import axios from "axios";
import { loadingFinish } from "../actions/Loading";
import { SETTINGS, LOGIN } from "../actions/types";
import history from "../../helpers/history";
import { logout } from "../actions/Auth";
import { toast } from "react-toastify";
import { updateUserSuccess, updateUser } from "../actions/Auth";
import { updateProfile } from "../actions/Settings";

const API_BASE = `${process.env.REACT_APP_API_BASE_URL}agent`;

function* handleChangePassword({ payload, history }) {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const apiUrl = `${API_BASE}/profile/password/edit`;
  const apiCall = async () => {
    try {
      const result = await axios.post(apiUrl, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      return result;
    } catch (error) {
      throw error;
    }
  };

  try {
    const result = yield call(apiCall);
    if (result === "error") {
      toast.error("Confirmation password does not match");
    } else if (result.data.status === "success") {
      sessionStorage.setItem("message", result.data.message);
      history.push("/agent/settings")
    } else {
      toast.error(result.data.message);
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  } finally {
    yield put(loadingFinish());
  }
}

function* handleChangePin({ payload, history }) {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const apiUrl = `${API_BASE}/profile/transaction/pin/edit`;
  const apiCall = async () => {
    try {
      const result = await axios.post(apiUrl, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      return result;
    } catch (error) {
      return error.response;
    }
  };

  try {
    const result = yield call(apiCall);

    if (result.status === 400) {
      result.data.pin.map((msg) => toast.error(msg));
    } else if (result.status === 200 && result.data.status === "error") {
      toast.error(result.data.message);
    } else {
      sessionStorage.setItem("message", result.data.message);
      history.push("/agent/settings")
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  } finally {
    yield put(loadingFinish());
  }
}

function* handleEditProfile({ payload, history }) {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const apiUrl = `${API_BASE}/profile/edit`;
  const apiCall = async () => {
    try {
      const result = await axios.post(apiUrl, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      return result;
    } catch (error) {
      throw error;
    }
  };

  try {
    const result = yield call(apiCall);
    if (result.status === 400) {
      toast.error(result.data.username[0]);
    } else if (result.status === 200) {
      sessionStorage.setItem("message", result.data.message);
      history.push("/agent/settings")
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  } finally {
    yield put(updateProfile());
    yield put(loadingFinish());
  }
}

function* handleResetEmail({ payload, history }) {
  const apiUrl = `${process.env.REACT_APP_API_BASE_URL}reset/email`;
  const apiCall = async () => {
    try {
      const result = await axios.post(
        apiUrl,
        { email: payload },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return result;
    } catch (error) {
      return error.response;
    }
  };

  try {
    const result = yield call(apiCall);
    if (result.data.status === "success")
      toast.success("Password reset link sent successfully.");
    else if (result.data.status === "error") toast.error(result.data.message);
    else toast.error(result.data.errors.email[0]);
  } catch (error) {
    throw error;
  } finally {
    yield put(loadingFinish());
  }
}

function* handleUpdateProfile() {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const apiUrl = `${process.env.REACT_APP_API_BASE_URL}profile/view`;
  const apiCall = async () => {
    try {
      const result = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return result;
    } catch (error) {
      return error;
    }
  };

  try {
    const result = yield call(apiCall);

    if (result.data.status === "success") {
      let localUser = JSON.parse(localStorage.getItem("user"));
      let { token, user } = localUser;
      let { wallet_reserved_account, agent_profile, ...rest } = user;
      rest = result.data.data;
      // yield put(updateUser(rest))
      user = { ...rest, wallet_reserved_account, agent_profile };
      const update = { token, user };
      localStorage.setItem("user", JSON.stringify(update));
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  } finally {
    yield put(loadingFinish());
  }
}

function* handleUpdateUser() {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const apiUrl = `${process.env.REACT_APP_API_BASE_URL}profile/view`;
  const apiCall = async () => {
    try {
      const result = await axios.get(apiUrl, {
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      });
      return result;
    } catch (error) {
      return error;
    }
  };
  try {
    const result = yield call(apiCall);

    if (result.data.status === "success") {
      yield put(updateUserSuccess(result.data.data));
    }
  } catch (err) {
    throw err;
    // let error = err
    // if (typeof err === "object") {
    //   if (err.response.status === 401) {
    //     yield put(logout())
    //     history.push("/login");
    //     toast.info("Your session has expired");
    //   } else {
    //     error = "An error occured. Pls try again";
    //   }
    // }
  }
}

const saversSaga = [
  takeLatest(SETTINGS.CHANGE_PASSWORD, handleChangePassword),
  takeLatest(SETTINGS.CHANGE_PIN, handleChangePin),
  takeLatest(SETTINGS.EDIT_PROFILE, handleEditProfile),
  takeLatest(SETTINGS.RESET_EMAIL, handleResetEmail),
  takeLatest(SETTINGS.UPDATE_PROFILE, handleUpdateProfile),
  takeLatest(LOGIN.UPDATE_USER, handleUpdateUser),
];

export default saversSaga;
